import React, { PureComponent, PropTypes } from 'react';

import { Footerbutton } from './footerbutton/main';

import statsd from '../../../../lib/StatsD';

import './styles.scss';

export class Footer extends PureComponent {
  constructor(props) {
    super(props);
    this.showRequests = this.showRequests.bind(this);
    this.showAdmin = this.showAdmin.bind(this);
    const leaveTextParts = [];
    const { leave } = props.features;
    const { unavailability } = props.features;
    if (leave.value === true) {
      leaveTextParts.push('Leave');
    }

    if (unavailability.value === true) {
      leaveTextParts.push('Unavailability');
    }

    const leaveText = leaveTextParts.join('/');

    this.state = {
      leaveText,
    };
  }

  showAdmin() {
    return this.props.admin ?
      <Footerbutton
        text='Settings'
        icon='fa fa-cog fa-2x'
        selection={this.props.activity === 'settings' ? 'selected' : null}
        onClick={() => {
          statsd.increment('buttons.settings');
          return this.props.setActivity('settings');
        }}
      />
      :
      undefined;
  }

  showRequests() {
    return (this.state.leaveText && this.props.userLevels.includes('employee')) ?
      <Footerbutton
        text={this.state.leaveText}
        icon='fa fa-plane fa-2x'
        selection={this.props.activity === 'request' ? 'selected' : null}
        onClick={() => {
          statsd.increment('leave.open_panel');
          return this.props.setActivity('request');
        }}
      />
      :
      null;
  }


  render() {
    if (!this.state.leaveText && !this.props.admin) {
      return null;
    }

    return (
      <div className='footer'>
        <div className='flexbox'>
          <Footerbutton
            text='Time Clock'
            icon='fa fa-clock-o fa-2x'
            selection={this.props.activity === 'home' ? 'selected' : null}
            onClick={() => this.props.setActivity('home')}
          />
          {this.showRequests()}
          {this.showAdmin()}
        </div>
      </div>
    );
  }
}

Footer.propTypes = {
  forwardActivity: PropTypes.func,
  setActivity: PropTypes.func,
  backwardActivity: PropTypes.func,
  activity: PropTypes.string,
  admin: PropTypes.bool,
  features: PropTypes.object,
  userId: PropTypes.number,
  authId: PropTypes.number,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/footer/main.jsx